/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimReportResult } from './TimReportResult';
import {
    TimReportResultFromJSON,
    TimReportResultFromJSONTyped,
    TimReportResultToJSON,
    TimReportResultToJSONTyped,
} from './TimReportResult';
import type { TimVisualReference } from './TimVisualReference';
import {
    TimVisualReferenceFromJSON,
    TimVisualReferenceFromJSONTyped,
    TimVisualReferenceToJSON,
    TimVisualReferenceToJSONTyped,
} from './TimVisualReference';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
    ReimbursementTypeToJSONTyped,
} from './ReimbursementType';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
    ContractSummaryToJSONTyped,
} from './ContractSummary';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';

/**
 * 
 * @export
 * @interface TimExecution
 */
export interface TimExecution {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    insurance_type: TimExecutionInsuranceTypeEnum;
    /**
     * 
     */
    state: TimExecutionStateEnum;
    /**
     * 
     */
    report?: string;
    /**
     * 
     */
    overridden_report?: string | null;
    /**
     * 
     */
    visual_references?: Array<TimVisualReference>;
    /**
     * 
     */
    report_result: TimReportResult;
    /**
     * 
     */
    created_at: string;
    /**
     * 
     */
    reimbursement_type?: ReimbursementType;
    /**
     * ISO timestamp of when the TIM execution finished
     */
    finished_at?: string;
    /**
     * 
     */
    payor?: InsurancePayor;
    /**
     * 
     */
    contract?: ContractSummary;
}


/**
 * @export
 */
export const TimExecutionInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type TimExecutionInsuranceTypeEnum = typeof TimExecutionInsuranceTypeEnum[keyof typeof TimExecutionInsuranceTypeEnum];

/**
 * @export
 */
export const TimExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
} as const;
export type TimExecutionStateEnum = typeof TimExecutionStateEnum[keyof typeof TimExecutionStateEnum];


/**
 * Check if a given object implements the TimExecution interface.
 */
export function instanceOfTimExecution(value: object): value is TimExecution {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('report_result' in value) || value['report_result'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function TimExecutionFromJSON(json: any): TimExecution {
    return TimExecutionFromJSONTyped(json, false);
}

export function TimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimExecution {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'state': json['state'],
        'report': json['report'] == null ? undefined : json['report'],
        'overridden_report': json['overridden_report'] === undefined ? undefined : json['overridden_report'] === null ? null : json['overridden_report'],
        'visual_references': json['visual_references'] == null ? undefined : ((json['visual_references'] as Array<any>).map(TimVisualReferenceFromJSON)),
        'report_result': TimReportResultFromJSON(json['report_result']),
        'created_at': json['created_at'],
        'reimbursement_type': json['reimbursement_type'] == null ? undefined : ReimbursementTypeFromJSON(json['reimbursement_type']),
        'finished_at': json['finished_at'] == null ? undefined : json['finished_at'],
        'payor': json['payor'] == null ? undefined : InsurancePayorFromJSON(json['payor']),
        'contract': json['contract'] == null ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function TimExecutionToJSON(json: any): TimExecution {
    return TimExecutionToJSONTyped(json, false);
}

export function TimExecutionToJSONTyped(value?: TimExecution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'payor_id': value['payor_id'],
        'insurance_type': value['insurance_type'],
        'state': value['state'],
        'report': value['report'],
        'overridden_report': value['overridden_report'],
        'visual_references': value['visual_references'] == null ? undefined : ((value['visual_references'] as Array<any>).map(TimVisualReferenceToJSON)),
        'report_result': TimReportResultToJSON(value['report_result']),
        'created_at': value['created_at'],
        'reimbursement_type': ReimbursementTypeToJSON(value['reimbursement_type']),
        'finished_at': value['finished_at'],
        'payor': InsurancePayorToJSON(value['payor']),
        'contract': ContractSummaryToJSON(value['contract']),
    };
}

